import { Row, Col, Button, Select, Form } from "antd";
import { BaseButtonsForm } from "components/common/forms/BaseButtonsForm";
import { MainFooter } from "components/layouts/main/MainFooter";
import {
  LayoutMaster,
} from "components/layouts/main/MainLayout/styles";
import { isEmpty } from "lodash";
import { useState } from "react";
import { FONT_SIZE_PX } from "config/theme/constants";
import { SearchOutlined } from "@ant-design/icons";

interface RejectedReasonsType {
  id: number;
  reason: string;
}
const TENDER_REJECTED_REASONS: RejectedReasonsType[] = [
  { id: 1, reason: "Capacity" },
  { id: 2, reason: "Point not Serviced" },
  { id: 3, reason: "Services Required" },
];

export const RejectedReasons = ({ onSubmit }: any) => {
  const [selectedItems, setSelectedItems] = useState<any>();
  const [form] = BaseButtonsForm.useForm();

  const handleChange = (value: any) => {
    form.setFieldsValue({
      rejectedId: value
    });
    setSelectedItems(value);
  };

  const handleSubmit = () => { 
    const selectedReasons = TENDER_REJECTED_REASONS.filter(item => selectedItems.includes(String(item.id)))
                                                 .map(item => item.reason);
    onSubmit(selectedReasons?.join(","));
  };

  return (
    <Row justify="space-between" style={{ width: "100%" }}>
      <Col span={24} style={{ marginTop: "5%", marginLeft: "2%" }}>
        <LayoutMaster>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <Form form={form} onFinish={handleSubmit} layout="vertical">
                    <Form.Item
                      name="rejectedId"
                      label="Reason for rejection"
                      rules={[
                        {
                          required: true,
                          message: "Select at least one reason for rejection.",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        style={{
                          width: "600px",
                        }}
                        placeholder="Select Options"
                        onChange={handleChange}
                        onSelect={(value) => {
                          if (value === "0") {
                            form.setFieldsValue({
                              rejectedId: "0",
                            });
                          }
                        }}
                        options={TENDER_REJECTED_REASONS?.map(
                          (rejectedReasons) => ({
                            value: rejectedReasons.id.toString(),
                            label: rejectedReasons.reason.toString(),
                          })
                        )}
                        filterOption={(inputValue, option: any) => {
                          return option?.label
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase());
                        }}
                        suffixIcon={
                          <SearchOutlined
                            style={{
                              pointerEvents: "none",
                              marginRight: isEmpty(selectedItems) ? 0 : 10,
                            }}
                          />
                        }
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        key="submit"
                        type="primary"
                        htmlType="submit"
                        style={{ fontSize: FONT_SIZE_PX.xs, minWidth: 100 }}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
        </LayoutMaster>
        <MainFooter isTwoColumnsLayout={false}>
          <div className="footer-content">
            &copy; {new Date().getFullYear()} PEGASUS LOGISTICS GROUP. ALL
            RIGHTS RESERVED
          </div>
        </MainFooter>
      </Col>
    </Row>
  );
};

export default RejectedReasons;
